import { TCommentId } from '../../store/model/card/types/IComment';

export const getCommentIdFromUrl = (
    url: string
): TCommentId => {
    const comment = url.match(/\/cmt-\d{16}/);
    return comment && Number(comment[0].slice(5));
}
